export default "__VITE_ASSET__Dj0hB$wo__"